module.exports = __webpack_public_path__ + "static/img/pic_1.2019135.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_1.jpeg
// module id = Nimc
// module chunks = 1